<template>
    <div>
        <div v-if="buttonText!=''">
            <Button @click="userChoseClick" :icon="icon">{{buttonText}}</Button>
            <span @click="clearSelectUser" class="clear">清空已选</span>
            <Collapse simple class="collapse">
                <Panel name="1">
                    已选择
                    <span class="select-count">{{selectDepts.length}}</span> 部门
                    <p slot="content">
                        <Tag v-for="(item, i) in selectDepts" :key="i" :name="item.id" color="default" closable @on-close="handleCancelUser">{{item.deptName}}</Tag>
                    </p>
                </Panel>
            </Collapse>
        </div>
        <Drawer title="选择部门" closable v-model="userModalVisible" width="800" class-name="drawer" :mask-style="maskStyle">
            <Form ref="searchUserForm" :model="searchUserForm" inline :label-width="55" class="search-form">
                <Form-item label="名称" prop="deptName">
                    <Input type="text" v-model="searchUserForm.deptName" clearable placeholder="请输入部门名称" style="width: 200px"/>
                </Form-item>
                <Form-item style="margin-left:-35px;" class="br">
                    <Button @click="handleSearchUser" type="primary" icon="ios-search">搜索</Button>
                    <Button @click="handleResetUser">重置</Button>
                </Form-item>
            </Form>
            <Table :loading="userLoading" border :columns="userColumns" :data="userData" ref="userTable"></Table>
            <Row type="flex" justify="end" class="code-row-bg page" style="margin: 10px 0;">
                <Page :current="searchUserForm.pageNumber" :total="totalUser" :page-size="searchUserForm.pageSize" @on-change="changeUserPage" @on-page-size-change="changeUserPageSize" :page-size-opts="[9,18,36]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
            <div class="drawer-footer">
                已选择
                <span class="select-count">{{selectDepts.length}}</span> 部门
                <Button @click="clearSelectUser" style="margin-left:10px">清空已选</Button>
                <Button @click="setSelectAllUser" type="info" style="margin-left:10px">勾选全部</Button>
                <Button @click="userModalVisible=false" type="primary" style="margin-left:10px">关闭</Button>
            </div>
        </Drawer>
    </div>
</template>

<script>
    import {deptList} from "@/api/bus";

    export default {
        name: "deptChoose",
        components: {
        },
        props: {
            buttonText: {
                type: String,
                default: "选择用户"
            },
            icon: {
                type: String,
                default: "md-person-add"
            },
            userType:""
        },
        data() {
            return {
                userLoading: true,
                userModalVisible: false,
                selectDepts: [],
                maskStyle:{
                  zIndex:9999
                },
                department: [],
                searchUserForm: {
                    departmentId: "",
                    deptName: "",
                    type: "",
                    status: "",
                    pageNumber: 1, // 当前页数
                    pageSize: 9, // 页面大小
                },
                userColumns: [
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "部门名称",
                        key: "deptName",
                        width: 145,
                        sortable: true
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 130,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "info",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.chooseUser(params.row);
                                            }
                                        }
                                    },
                                    "添加该部门"
                                )
                            ]);
                        }
                    }
                ],
                userData: [],
                totalUser: 0,
            };
        },
        methods: {
            userChoseClick(){
                this.getDeptDataList();
                this.userModalVisible=true
            },
            showDrawer() {
                this.userModalVisible = true;
            },
            handleSelectDep(v) {
                this.searchUserForm.departmentId = v;
            },
            changeUserPage(v) {
                this.searchUserForm.pageNumber = v;
                this.getDeptDataList();
            },
            changeUserPageSize(v) {
                this.searchUserForm.pageSize = v;
                this.getDeptDataList();
            },
            getDeptDataList() {
                this.userLoading = true;
                deptList(this.searchUserForm).then(res => {
                    this.userLoading = false;
                    if (res.status === true) {
                        this.userData = res.data.rows;
                        this.totalUser = res.data.total;
                    }
                });
            },
            handleSearchUser() {
                this.searchUserForm.pageNumber = 1;
                this.searchUserForm.pageSize = 9;
                this.getDeptDataList();
            },
            handleResetUser() {
                this.$refs.searchUserForm.resetFields();
                this.searchUserForm.pageNumber = 1;
                this.searchUserForm.pageSize = 9;
                this.$refs.dep.clearSelect();
                this.searchUserForm.departmentId = "";
                // 重新加载数据
                this.getDeptDataList();
            },
            setSelectUser(v) {
                this.selectDepts = v;
                // this.$emit("on-change", this.selectDepts);
            },
            setSelectAllUser() {
                let data = [];
                this.userData.forEach(e => {
                    let u = {
                        id: e.id,
                        deptName: e.deptName
                    };
                    data.push(u);
                });
                this.selectDepts = data;
                this.$emit("on-change", data);
            },
            chooseUser(v) {
                // 去重
                let that = this;
                let flag = true;
                this.selectDepts.forEach(e => {
                    if (v.id == e.id) {
                        that.$Message.warning("已经添加过啦，请勿重复选择");
                        flag = false;
                    }
                });
                if (flag) {
                    let u = {
                        id: v.id,
                        deptName: v.deptName
                    };
                    this.selectDepts.push(u);
                    this.$emit("on-change", this.selectDepts);
                    this.$Message.success(`添加部门 ${v.deptName} 成功`);
                }
            },
            clearSelectUser() {
                this.selectDepts = [];
                this.$emit("on-change", this.selectDepts);
            },
            handleCancelUser(e, id) {
                // 删除所选用户
                let newArray = [];
                this.selectDepts.forEach(e => {
                    if (id != e.id) {
                        newArray.push(e);
                    }
                });
                this.selectDepts = newArray;
                this.$emit("on-change", this.selectDepts);
                this.$Message.success("删除所选用户成功");
            }
        },
        created() {

        }
    };
</script>

<style lang="less">
    .clear {
        font-size: 12px;
        margin-left: 15px;
        color: #40a9ff;
        cursor: pointer;
    }
    .collapse {
        font-size: 12px;
        margin-top: 15px;
        width: 500px;
    }

    .drawer-footer {
        z-index: 10;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }

    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .drawer{
        z-index: 10000;
    }
</style>

